import { EMERGE_MODE, MODAL_STATUS } from '@/utils/consts'

export default {
  modalState: MODAL_STATUS.NONE,
  emergeMode: EMERGE_MODE.NONE
}
